module.exports = __webpack_public_path__ + "static/media/cases_3d_04f.6661e6be.jpg";